import moment from "moment";

export const API_KEY_STATUS = Object.freeze({
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    EXPIRED: "Expired",
});

export const API_KEY_STATUS_COLORS = Object.freeze({
    [API_KEY_STATUS.ACTIVE]: "green",
    [API_KEY_STATUS.INACTIVE]: "default",
    [API_KEY_STATUS.EXPIRED]: "red",
});

export function isApiKeyExpired(apiKey) {
    return Boolean(apiKey && apiKey.expiresAt && moment.utc(apiKey.expiresAt).isBefore(moment()));
}

const STATUS_LABELS = Object.freeze({
    ACTIVE: API_KEY_STATUS.ACTIVE,
    INACTIVE: API_KEY_STATUS.INACTIVE,
    EXPIRED: API_KEY_STATUS.EXPIRED,
});

export function getApiKeyStatus(apiKey) {
    if (apiKey && apiKey.status && STATUS_LABELS[apiKey.status]) {
        return STATUS_LABELS[apiKey.status];
    }
    if (isApiKeyExpired(apiKey)) {
        return API_KEY_STATUS.EXPIRED;
    }
    return apiKey && apiKey.active ? API_KEY_STATUS.ACTIVE : API_KEY_STATUS.INACTIVE;
}

// "Aug 10, 2026" style used in the api key list; "Never" when the value is empty.
export function formatApiKeyDate(value, emptyText = "Never") {
    return value ? moment.utc(value).local().format("MMM D, YYYY") : emptyText;
}

export function formatApiKeyDateTime(value, emptyText = "Never") {
    return value ? moment.utc(value).toDate().toLocaleString() : emptyText;
}

// Records carry the creator's user id; the users list resolves it to an email when the caller can see users.
export function resolveUserEmail(userList, userId) {
    if (!userId) {
        return "";
    }
    let user = (userList || []).find((item) => item && item.userId === userId);
    return user && user.email ? user.email : userId;
}
